var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 64.874702,
    cy: 58.380615,
    rx: 15.981977,
    ry: 15.520984
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 32.661942,
    cy: 36.037827,
    rx: 8.6037235,
    ry: 8.450058
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 25.354612,
    cy: 96.962173,
    rx: 8.6037235,
    ry: 8.450058
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 96.18676,
    cy: 31.122932,
    rx: 8.6037235,
    ry: 8.450058
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 65.921989,
    cy: 98.191498,
    rx: 8.6037235,
    ry: 8.450058
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 98.19149,
    cy: 80.981094,
    rx: 8.6037235,
    ry: 8.450058
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 52.553191,68.380615 31.040189,90.661939",
    className: "cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 65,73.758865 65.153664,89.27896",
    className: "cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 77.600473,67.765957 13.21513,8.605201",
    className: "cls-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 89.60241,36.630522 76.686747,48.46988",
    className: "cls-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m 38.746988,41.473896 12.646586,8.341365",
    className: "cls-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrick);
export default __webpack_public_path__ + "static/media/brick.67767a679f3b41ad5f84314723d96d6a.svg";
export { ForwardRef as ReactComponent };